module.exports = __webpack_public_path__ + "img/120.6fa26c4a.jpg";